import refs from '../helpers/refs'

class CBlockFaq {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    const links = document.querySelector('#c-faq-links ul')

    if (links) {
      const link = document.createElement('li')
      const text = this.$refs.header.dataset.heading
      const anchor = this.$refs.header.dataset.anchor

      const classLink = links.dataset.classLink || 'c-faq-links__anchor-link block md:hover:underline p-2 pt-3 md:pt-0 mb-2 md:mb-0'
      const classSpan = links.dataset.classSpan || 'c-faq-links__anchor-link-border block border-b-4 md:border-b-0 border-transparent text-grey-500 font-bold whitespace-nowrap md:whitespace-normal uppercase text-body-1'

      link.innerHTML = `
        <a class="${classLink}" href="#${anchor}">
          <span class="${classSpan}">
            ${text}
          </span>
        </a>`

      links.appendChild(link)
    }

    // On dropdown click, close other dropdowns (from other c-block-faqs)
    const blockDropdowns = this.$root.querySelectorAll('.c-block-faq__checkbox')
    const allDropdowns = document.querySelectorAll('.c-block-faq__checkbox')

    if (blockDropdowns) {
      blockDropdowns.forEach((activeDropdown) => {
        activeDropdown.addEventListener('change', () => {
          allDropdowns.forEach((dropdown) => {
            if (dropdown !== activeDropdown) {
              dropdown.checked = false
            }
          })
        })
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-block-faq')
    .forEach(el => new CBlockFaq(el))
})
